import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import {
  GenerateLMNResponse,
  NewEvaluationResponse
} from '@core/models/evaluation/evaluation';
import { EvaluationService } from '@core/services/evaluation/evaluation.service';
import {
  MockEval,
  MockGenerated
} from '@features/patients/lmn/_mocks/mock-eval.mock';
import { Observable, of } from 'rxjs';

export const evaluationResolver: ResolveFn<
  Observable<NewEvaluationResponse | GenerateLMNResponse | any>
> = (route) => {
  const _evaluation = inject(EvaluationService);
  const evalKey: number = Number(route.paramMap?.get('evalId'));
  const isReturning: boolean = Boolean(route.queryParamMap?.get('returning'));

  return isReturning
    ? _evaluation.viewLMN(evalKey)
    : _evaluation.getEvaluation(evalKey);
};
